import component from "./index.component";
import withCurrentUser from "lib/containers/withCurrentUser";

export default withCurrentUser(component);
